import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import {
  PAYROLL_STATUS_CLOSED,
  PAYROLL_STATUS_CREATED,
  PAYROLL_STATUS_PREVIEW,
  PAYROLL_STATUS_SPLIT,
  PAYROLL_STATUS_WITHDRAWN,
  PayrollStatus,
} from "@/schemas/payroll";
import {
  CirclePlus,
  ClockPlusIcon,
  EyeIcon,
  SplitIcon,
  XIcon,
} from "lucide-react";
import { useTranslation } from "react-i18next";

interface PayrollStatusBadgeProps {
  status: PayrollStatus;
}

const CLASS_NAMES_BY_STATUS: Record<PayrollStatus, string> = {
  [PAYROLL_STATUS_PREVIEW]: "bg-sky-500 hover:bg-sky-500",
  [PAYROLL_STATUS_SPLIT]: "bg-cyan-500 hover:bg-cyan-500",
  [PAYROLL_STATUS_CREATED]: "bg-green-700 hover:bg-green-700",
  [PAYROLL_STATUS_CLOSED]: "bg-red-700 hover:bg-red-700",
  [PAYROLL_STATUS_WITHDRAWN]: "bg-purple-700 hover:bg-purple-700",
};

const getIcon = (status: PayrollStatus) => {
  switch (status) {
    case PAYROLL_STATUS_CREATED:
      return CirclePlus;
    case PAYROLL_STATUS_SPLIT:
      return SplitIcon;
    case PAYROLL_STATUS_CLOSED:
      return XIcon;
    case PAYROLL_STATUS_WITHDRAWN:
      return ClockPlusIcon;
    case PAYROLL_STATUS_PREVIEW:
    default:
      return EyeIcon;
  }
};

export const PayrollStatusBadge = ({ status }: PayrollStatusBadgeProps) => {
  const { t } = useTranslation();
  const Icon = getIcon(status);

  return (
    <Badge className={cn("text-xs", CLASS_NAMES_BY_STATUS[status])}>
      <Icon className="w-4 h-4 mr-1" />
      {t(`payrolls.enum.payroll_status.${status}`)}
    </Badge>
  );
};
